import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaRuler } from 'react-icons/fa';

import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import { AccessibilityOption } from './AccessibilityButton';

const ReadingGuide = () => {
  const { isReadingGuideEnabled, setIsReadingGuideEnabled } = useAccessibilityContext();

  const handleToggle = () => {
    if (setIsReadingGuideEnabled) {
      setIsReadingGuideEnabled(!isReadingGuideEnabled);
    }
  };

  return (
    <>
      <AccessibilityOption
        name="Línea de lectura"
        icon={<FaRuler className="size-3 fill-white" />}
        onClick={handleToggle}
      />
      {isReadingGuideEnabled && <ReadingGuideOverlay />}
    </>
  );
};

const ReadingGuideOverlay = () => {
  const [mouseY, setMouseY] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMouseY(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  if (!mounted) return null;

  const guideHeight = 4; // Altura de la línea de lectura en px
  const topPosition = mouseY - guideHeight / 2;

  return createPortal(
    <div
      className="pointer-events-none fixed left-0 bg-primary"
      style={{
        top: `${topPosition}px`,
        height: `${guideHeight}px`,
        width: '100vw',
        zIndex: 'var(--z-toast)',
      }}
    />,
    document.body
  );
};

export default ReadingGuide;
